import ReactECharts from 'echarts-for-react'

interface DonutChartProps {
  data: Array<{ name: string; value: number; color: string }>
  centerLabel?: string
  centerValue?: string | number
  height?: number
}

export function DonutChart({ data, centerLabel, centerValue, height = 200 }: DonutChartProps) {
  const option = {
    tooltip: {
      trigger: 'item',
      backgroundColor: '#1B2559',
      borderColor: '#2D3A6A',
      textStyle: { color: '#fff', fontSize: 12 },
      formatter: '{b}: {c} ({d}%)',
    },
    legend: { show: false },
    series: [
      {
        type: 'pie',
        radius: ['55%', '80%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        label: centerValue !== undefined ? {
          show: true,
          position: 'center',
          formatter: () => `{val|${centerValue}}\n{lab|${centerLabel || ''}}`,
          rich: {
            val: { fontSize: 22, fontWeight: 'bold', color: '#1B2559', fontFamily: 'JetBrains Mono', lineHeight: 28 },
            lab: { fontSize: 11, color: '#8B8FA7', lineHeight: 16 },
          },
        } : { show: false },
        data: data.map(d => ({
          value: d.value,
          name: d.name,
          itemStyle: { color: d.color },
        })),
        emphasis: {
          itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0, 0, 0, 0.1)' },
        },
      },
    ],
  }

  return <ReactECharts option={option} style={{ height }} />
}
